import React, { useEffect, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  DateInput,
  TextInput,
  RadioInput,
  CheckBoxInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import DatePickerComponent from "../../components/common/ui/Inputs/DatePickerComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  ContentState,
  convertFromHTML,
  convertFromRaw,
  convertToRaw,
  EditorState,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import { history } from "../../_helpers";
import { masterActions, noticeAction, authActions } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import noticeSchema from "../../validation/noticeSchema";
// import { stateFromHTML } from "draft-js-import-html";
import { MenuItem, StoredProcedures } from "../../_helpers/enumerator";
import { MinDate } from "../../utils/formatTime";

function AddOrEditNotice() {
  const dispatch = useDispatch();
  const location = useLocation();

  const { Status } = useSelector((state) => state.dropdownOptions);
  // const facilityCode = useSelector((x) => x?.master?.commonFacilityCode);
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );
  const { noticeSearchdata, loading } = useSelector((x) => x?.notice);
  const { noticeData, addOrUpdateNoticeResponse, KIOSKDropDownResponse } =
    useSelector((x) => x?.notice);
  // Getting user details
  const { user } = useSelector((x) => x.auth);
  const Size = Quill.import("attributors/style/size");

  Size.whitelist = [
    "8pt",
    "10pt",
    "12pt",
    "14pt",
    "18pt",
    "24pt",
    "36pt",
    "48px",
  ];
  Quill.register(Size, true);

  var Font = Quill.import("formats/font");
  Font.whitelist = [
    "arial",
    "courier-new",
    "georgia",
    "tahoma",
    "times-new-roman",
    "verdana",
    "impact",
    "wingdings",
  ];
  Quill.register(Font, true);

  const modules = {
    toolbar: [
      [{ font: Font.whitelist }],
      [{ size: Size.whitelist }],
      // [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["link"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false, // Prevents Quill from altering pasted content
    },
  };

  const noticeID = location?.state ? location?.state?.noticeID : 0;
  const prevFacilityCodeRef = useRef(facilityCode);
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );

  // const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(ContentState.createFromText("    "))
  );
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const [originalKiosks, setOriginalKiosks] = useState([]);
  const [editorContent, setEditorContent] = useState("");
  const [editorContentNew, setEditorContentNew] = useState("");
  const [KIOSKDropDown, setKIOSKDropDown] = useState([]);
  const [isKisoksSelectAll, setIsKisoksSelectAll] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [IsFirst, setIsFirst] = useState(0);
  //   const htmlToDelta = (htmlContent) => {
  //     let tempDiv = document.createElement("div");
  //     tempDiv.innerHTML = htmlContent.trim();

  //     let deltaOps = [];

  //     const processElement = (element , listType = null) => {
  //         if (element.nodeType === Node.TEXT_NODE) {
  //             let text = element.textContent.trim();
  //             if (text) deltaOps.push({ insert: text + "\n" });
  //             return;
  //         }

  //         let text = element.textContent.trim();
  //         let attributes = {};

  //         // Apply text formatting
  //         // if (element.style.textDecoration?.includes("underline")) attributes.underline = true;
  //         let textDecoration = window.getComputedStyle(element).textDecorationLine || element.style.textDecoration;

  //         if (textDecoration.includes("underline")) attributes.underline = true;
  //         if (textDecoration.includes("line-through")) attributes.strike = true;

  //         if (element.style.fontWeight === "bold" || ["B", "STRONG"].includes(element.tagName)) attributes.bold = true;
  //         if (element.style.fontStyle === "italic" || ["I", "EM"].includes(element.tagName)) attributes.italic = true;
  //         if (element.style.fontSize) attributes.size = element.style.fontSize;
  //         if (element.style.fontFamily) attributes.font = element.style.fontFamily;
  //         if (element.style.color) attributes.color = element.style.color;
  //         if (element.style.backgroundColor) attributes.background = element.style.backgroundColor;
  //         if (element.style.textAlign) attributes.align = element.style.textAlign;
  //         if (element.style.verticalAlign === "super") attributes.script = "super";
  //         if (element.style.verticalAlign === "sub") attributes.script = "sub";
  //         if (element.style.marginLeft) attributes.indent = parseInt(element.style.marginLeft) / 30;

  //         // Handle Ordered and Unordered Lists
  //         if (element.tagName === "UL") {
  //             element.childNodes.forEach(child => processElement(child, "bullet"));
  //             return;
  //         }
  //         if (element.tagName === "OL") {
  //             element.childNodes.forEach(child => processElement(child, "ordered"));
  //             return;
  //         }
  //         if (element.tagName === "LI") {
  //             attributes.list = listType;
  //             deltaOps.push({ insert: text + "\n", attributes });
  //             return;
  //         }

  //         // Handle Links
  //         if (element.tagName === "A" && element.href) {
  //             deltaOps.push({ insert: text, attributes: { ...attributes, link: element.href } });
  //             return;
  //         }

  //         // Prevent extra `<br>` causing blank list items
  //         if (element.tagName === "BR") {
  //             if (deltaOps.length === 0 || (deltaOps.length > 0 && deltaOps[deltaOps.length - 1].insert === "\n")) return;
  //             deltaOps.push({ insert: "\n" });
  //             return;
  //         }

  //         // Handle Images
  //         if (element.tagName === "IMG" && element.src) {
  //             deltaOps.push({ insert: { image: element.src } });
  //             return;
  //         }

  //         if (text) {
  //             deltaOps.push({ insert: text + "\n", attributes });
  //         }
  //             // element.childNodes.forEach(child => processElement(child, attributes));

  //     };

  //     tempDiv.childNodes.forEach((node) => processElement(node));

  //     return { ops: deltaOps };
  // };

  const tooltipMap = {
    "ql-bold": "Bold",
    "ql-italic": "Italic",
    "ql-underline": "Underline",
    "ql-strike": "Strikethrough",
    "ql-blockquote": "Blockquote",
    "ql-list-ordered": "Ordered List",
    "ql-list-bullet": "Bullet List",
    "ql-script-sub": "Subscript",
    "ql-script-super": "Superscript",
    "ql-indent--1": "Decrease Indent",
    "ql-indent-+1": "Increase Indent",
    "ql-direction": "Text Direction (LTR/RTL)",
    "ql-color": "Text Color",
    "ql-background": "Background Color",
    "ql-align": "Align Text",
    "ql-link": "Insert Link",
    "ql-image": "Insert Image",
    "ql-video": "Insert Video",
    "ql-clean": "Remove Formatting",
  };

  // Function to add tooltips
  const addTooltips = () => {
    setTimeout(() => {
      const toolbar = document.querySelector(".ql-toolbar");
      if (!toolbar) return;

      const toolbarButtons = toolbar.querySelectorAll("button, .ql-picker");

      toolbarButtons.forEach((button) => {
        const classList = button.className.split(" ");

        // Handle standard tooltips
        classList.forEach((cls) => {
          if (tooltipMap[cls]) {
            button.setAttribute("title", tooltipMap[cls]);
          }
        });

        // Handle special cases where buttons have values
        if (button.classList.contains("ql-list")) {
          const value = button.getAttribute("value");
          if (value === "ordered") {
            button.setAttribute("title", "Ordered List");
          } else if (value === "bullet") {
            button.setAttribute("title", "Bullet List");
          }
        }

        if (button.classList.contains("ql-script")) {
          const value = button.getAttribute("value");
          if (value === "sub") {
            button.setAttribute("title", "Subscript");
          } else if (value === "super") {
            button.setAttribute("title", "Superscript");
          }
        }

        if (button.classList.contains("ql-indent")) {
          const value = button.getAttribute("value");
          if (value === "-1") {
            button.setAttribute("title", "Decrease Indent");
          } else if (value === "+1") {
            button.setAttribute("title", "Increase Indent");
          }
        }
      });
    }, 500);
  };

  useEffect(() => {
    if (quillRef.current) {
      addTooltips();
    }
  }, []);

  // const [IsFirst,setIsFirst] = useState(0);
  const htmlToDelta = (htmlContent, IsExistingNotice) => {
    let tempDiv = document.createElement("div");
    //tempDiv.innerHTML = htmlContent.trim().replace(/<br\s*\/?>/gi, "");
    if (!htmlContent?.includes("<p>")) {
      htmlContent = htmlContent.replace(
        /(<br\s*\/?>)(\s*<br\s*\/?>)+/g,
        (match) => match.replace(/<br\s*\/?>/, "") // Remove only one <br/>
      );
    }

    tempDiv.innerHTML = htmlContent.trim();

    let deltaOps = [];
    let IsParent = 1;
    let IsFirst = 0;

    const parseNode = (node, parentAttributes = {}) => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.trim()) {
          IsFirst = 1;

          deltaOps.push({
            insert: node.textContent,
            attributes: { ...parentAttributes },
          });
        }
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        let attributes = { ...parentAttributes }; // Inherit styles from parent

        // Apply styles from tags
        if (
          node.tagName === "B" ||
          node.tagName === "STRONG" ||
          node.style.fontWeight === "bold"
        )
          attributes.bold = true;
        if (
          node.tagName === "I" ||
          node.tagName === "EM" ||
          node.style.fontStyle === "italic"
        )
          attributes.italic = true;
        if (
          node.tagName === "U" ||
          (node.style.textDecoration &&
            node.style.textDecoration.includes("underline"))
        ) {
          attributes.underline = true;
        }

        if (
          node.tagName === "S" ||
          node.tagName === "STRIKE" ||
          node.style.textDecoration.includes("line-through")
        )
          attributes.strike = true;

        if (
          node.tagName === "SUP" ||
          (node.tagName === "SUB" && IsExistingNotice == 0 && IsParent === 1)
        ) {
          IsParent = 0;
          attributes.script = node.tagName === "SUP" ? "super" : "sub";
          node.childNodes.forEach((child) => parseNode(child, attributes));
          return;
        } else {
          if (node.tagName === "SUP" || node.style?.verticalAlign === "super")
            attributes.script = "super";
          if (node.tagName === "SUB" || node.style?.verticalAlign === "sub")
            attributes.script = "sub";
        }

        // Handle alignment classes
        node.classList.forEach((className) => {
          if (className.startsWith("ql-align-")) {
            attributes.align = className.replace("ql-align-", "");
          }
        });

        node.classList.forEach((className) => {
          if (className.startsWith("ql-indent-")) {
            let indentLevel = parseInt(className.replace("ql-indent-", ""), 10);
            if (!isNaN(indentLevel)) {
              attributes.indent = indentLevel;
            }
          }
        });

        // Ensure paragraphs are properly separated
        if (node.tagName === "P") {
          let lengthBefore = deltaOps.length;
          node.childNodes.forEach((child) => parseNode(child, attributes));
          let lengthAfter = deltaOps.length;
          if (lengthBefore !== lengthAfter || node.textContent.trim() === "") {
            IsParent = 0;
            deltaOps.push({ insert: "\n", attributes });
          }
          return;
        }

        if (node.tagName === "BLOCKQUOTE") {
          let lengthBefore = deltaOps.length;
          node.childNodes.forEach((child) =>
            parseNode(child, { blockquote: true })
          );
          let lengthAfter = deltaOps.length;

          if (lengthBefore !== lengthAfter) {
            IsParent = 0;
            deltaOps.push({ insert: "\n", attributes: { blockquote: true } });
          }
          return;
        }

        if (node.tagName === "A") {
          attributes.link = node.getAttribute("href");
        }

        if (node.style.color) attributes.color = node.style.color;
        if (node.style.backgroundColor)
          attributes.background = node.style.backgroundColor;
        if (node.style.fontSize) attributes.size = node.style.fontSize;
        if (node.style.textAlign) attributes.align = node.style.textAlign;
        if (node.style.marginLeft)
          attributes.indent = Math.floor(parseInt(node.style.marginLeft) / 40);
        if (node.style.fontFamily) {
          let font = node.style.fontFamily.split(",")[0].toLowerCase().trim();
          font = font.replace(/["']/g, "").replace(/\s+/g, "-"); // Remove quotes & replace spaces with hyphens

          const fontMap = {
            arial: "arial",
            "courier-new": "courier-new",
            georgia: "georgia",
            tahoma: "tahoma",
            "times-new-roman": "times-new-roman",
            verdana: "verdana",
            impact: "impact",
            wingdings: "wingdings",
          };

          if (fontMap[font]) {
            attributes.font = fontMap[font];
          }
        }

        if (node.classList.length > 0) {
          node.classList.forEach((cls) => {
            if (cls.startsWith("ql-font-")) {
              attributes.font = cls.replace("ql-font-", "");
            }
          });
        }

        // Handle lists
        if (node.tagName === "LI") {
          let listType =
            node.parentElement.tagName === "OL" ? "ordered" : "bullet";
          let inlineAttributes = { ...attributes }; // Preserve inline styles

          let childDeltaOps = [];
          IsParent = 0;
          node.childNodes.forEach((child) => {
            if (child.nodeType === Node.TEXT_NODE) {
              childDeltaOps.push({
                insert: child.textContent,
                attributes: { ...inlineAttributes },
              });
            } else {
              parseNode(child, inlineAttributes);
            }
          });

          // Merge all child text into a single insert operation
          if (childDeltaOps.length > 0) {
            deltaOps.push(...childDeltaOps);
          }

          // Ensure the list formatting is applied

          deltaOps.push({ insert: "\n", attributes: { list: listType } });
          return;
        }

        if (node.childNodes.length > 0) {
          node.childNodes.forEach((child) => parseNode(child, attributes));
          return;
        }

        if (
          IsExistingNotice == 0 &&
          IsParent === 1 &&
          node.tagName === "BR" &&
          deltaOps.length > 0
        ) {
          deltaOps.push({ insert: "\n" });
          //IsFirst = 0
          //IsParent = 0;
          return;
        } else if (
          IsExistingNotice == 1 &&
          deltaOps.length > 0 &&
          IsParent === 1 &&
          node.tagName === "BR"
        ) {
          deltaOps.push({ insert: "\n" });
          IsExistingNotice = 0;
          return;
        }

        if (
          IsExistingNotice == 0 &&
          IsParent === 1 &&
          deltaOps.length > 0 &&
          IsFirst === 1
        ) {
          deltaOps.push({ insert: "\n" });
          //IsFirst = 0
        }

        IsParent = 0;
        node.childNodes.forEach((child) => parseNode(child, attributes));
        IsParent = 1;
      }
    };

    IsFirst = 0;
    tempDiv.childNodes.forEach((node) => parseNode(node));
    IsFirst = 1;
    return { ops: deltaOps };
  };

  const insertHtmlAsDelta = (htmlContent, IsExistingNotice) => {
    if (!quillRef.current) {
      setTimeout(() => insertHtmlAsDelta(htmlContent, IsExistingNotice), 100);
      return;
    }
    let delta = htmlToDelta(htmlContent, IsExistingNotice);
    quillRef.current.getEditor().setContents(delta);
  };

  // useEffect(() => {
  //   if (editorRef.current) {
  //     quillRef.current = new Quill(editorRef.current, {
  //       theme: "snow",
  //       modules: {
  //         toolbar: [
  //           ["bold", "italic", "underline", "strike"],
  //         ],
  //       },
  //       formats: ["bold", "italic", "underline", "strike", "color", "background"],
  //     });

  //     // Example HTML content
  //     const dynamicHtml = result?.payload?.NoticeDispaly;

  //     insertHtmlAsDelta(dynamicHtml);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (!noticeID) {
  //     // Reset only when adding a new notice
  //     // dispatch(noticeAction?.resetForm());
  //   }
  //   getKISOKSList();
  // }, [noticeID]); // Reset when noticeID changes

  useEffect(() => {
    if (noticeID) {
      //   getSpecificNoticeDetails();
    } else {
      dispatch(noticeAction.resetForm());
      setEditorContent("");
    }
    getKISOKSList();
  }, [noticeID]);

  const handleReset = () => {
    if (noticeID > 0) {
      setKIOSKDropDown([...originalKiosks]);
      getSpecificNoticeDetails();
      const isAllSelected = originalKiosks.every((kiosk) => kiosk.isActive);
      setIsKisoksSelectAll(isAllSelected);
    } else {
      dispatch(noticeAction.resetForm());
      setEditorState(EditorState.createEmpty());

      const restoredKiosks = KIOSKDropDownResponse.map((kiosk) => ({
        ...kiosk,
        isActive: false,
      }));
      setKIOSKDropDown(restoredKiosks);
      dispatch(noticeAction.updateKIOSKList(restoredKiosks));
      setIsKisoksSelectAll(false);
    }

    setErrorMessage({});
    if (quillRef.current) {
      quillRef.current.getEditor().root.innerHTML = ""; // Clear editor content
    }
    dispatch(noticeAction.resetForm());
  };




  //for redirecting when facility code change
  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("NoticeList");
    }
  }, [facilityCode]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, []);

  useEffect(() => {
    switch (addOrUpdateNoticeResponse?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: facilityCode,
            ProcedureName: StoredProcedures?.MangementUserCPU,
            UserAction: `Created a New Notice ( NoticeTitle - ${noticeData?.NoticeTitle} )`,
          })
        );
        showToastNotification(
          "Notices information has been saved successfully",
          "success"
        );
        history.navigate("NoticeList");
        // const searchParams = { ...noticeSearchdata };
        // searchParams.pageNo = 1;
        // searchParams.rowCountPerPage = 10;
        // dispatch(noticeAction?.setNoticeSearch(searchParams));
        dispatch(noticeAction?.resetResponse());
        // dispatch(noticeAction?.resetNoticeSearch());
        break;
      case 2:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: facilityCode,
            ProcedureName: StoredProcedures?.MangementUserCPU,
            UserAction: `Updated Notice Information ( NoticesID ${noticeID} )`,
          })
        );
        showToastNotification(
          "Notice information has been updated successfully",
          "success"
        );
        // noticeAction.setNoticeData({});
        history.navigate("NoticeList");
        dispatch(noticeAction?.resetResponse());
        // dispatch(noticeAction?.resetNoticeSearch());
        break;

      case -1:
        showToastNotification("Error in insert or update", "error");
        dispatch(noticeAction?.resetResponse());
        break;

      case -2:
        showToastNotification("No Kiosk is been selected.", "error");
        dispatch(noticeAction?.resetResponse());
        break;

      case -3:
        showToastNotification("Notice title already exists.", "error");
        dispatch(noticeAction?.resetResponse());
        break;

      default:
        break;
    }
  }, [addOrUpdateNoticeResponse]);

  const getKISOKSList = () => {
    // const noticeInfo = { ...noticeData };
    dispatch(noticeAction.KIOSKDropDown(facilityCode))
      .then((result) => {
        const kiosksList = result?.payload;

        if (noticeID > 0) {
          getSpecificNoticeDetails(kiosksList);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to get KIOSK Data", "error");
      });
  };

  const customStyleMap = {
    FONT_SIZE_96: {
      fontSize: "96px",
    },
    BOLD: {
      fontWeight: "bold",
    },
    ITALIC: {
      fontStyle: "italic",
    },
  };

  const getSpecificNoticeDetails = (kiosksList) => {
    if (noticeID === 0) return;
    dispatch(noticeAction?.getNoticeDetails(noticeID))
      .then((result) => {
        const noticePermissionList = result?.payload?.NoticePermissionList;
        //for kisosk list
        if (kiosksList && kiosksList?.length > 0) {
          const kioskDD = kiosksList?.map((item) => {
            if (
              noticePermissionList?.some(
                (permission) => permission?.KiosksID === item?.value
              )
            ) {
              return { ...item, isActive: true };
            }
            return item;
          });

          setOriginalKiosks(kioskDD);

          const isKioskListChanged = !kiosksList.every((item, index) => {
            return item.isActive === kioskDD[index]?.isActive;
          });
          const isAllActive = kioskDD.every((item, index) => {
            return item.isActive === true;
          });
          setIsKisoksSelectAll(isAllActive ? true : false);

          if (isKioskListChanged) {
            dispatch(noticeAction?.updateKIOSKList(kioskDD));
          }
        }

        //editor
        const editedValue = result?.payload?.NoticeDispaly;
        const IsExistingNotice = result?.payload?.IsExistingNotice;


        if (typeof editedValue === "string") {
          setTimeout(() => {
            if (quillRef.current) {
              insertHtmlAsDelta(editedValue, IsExistingNotice);
            }
          }, 200);
        }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };


  const [insetupdateflag, setinsetupdateflag] = useState(0);
  const onEditorStateChange = (content) => {
    let cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");

    if (editorContent === "") {
      setEditorContent(cleanedContent);
    } else if (editorContent !== "" && insetupdateflag === 0) {
      setEditorContent(cleanedContent);

      const data = { ...noticeData, NoticeDispaly: cleanedContent };
      dispatch(noticeAction.setNoticeData(data));
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  // Prevent Right-Click (Optional)
  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleOnBlur = (e) => {
    let { name, value } = e.target;

    // const { error } = postalMailSchema(mailDocumentInfo);
    const { error } = noticeSchema(noticeData);

    if (error?.details) {
      // Extract the error message for the specific field
      const fieldError = error.details.find((e) => e.path.toString() === name);

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
      }));

      // Select the input element
      const element = document.querySelector(`[name="${name}"]`);

      if (element) {
        if (fieldError) {
          // Add the error class if there's a validation issue
          element.classList.add("input-error");
        } else {
          // Remove the error class if validation passes
          element.classList.remove("input-error");
        }
      }
    } else {
      // Clear the error message if there's no validation error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Remove the error class from the input field
      const element = document.querySelector(`[name="${name}"]`);
      if (element) {
        element.classList.remove("input-error");
      }
    }
  };

  const handleChange = (e, input) => {
    const data = { ...noticeData };
    if (input) {
      const date = e?.getDate();
      const month = String(e?.getMonth() + 1).padStart(2, "0");
      const year = e?.getFullYear();
      const fullDate = month + "/" + date + "/" + year;
      data[input] = e ? fullDate : null;
      dispatch(noticeAction?.setNoticeData(data));
      return;
    }
    const { name, value, type } = e?.target;
    data[name] = type === "radio" ? parseInt(value) : value;
    dispatch(noticeAction?.setNoticeData(data));
  };

  const handleDateEnterKey = (event, name) => {
    const data = { ...noticeData };
    if (event.key === "Enter" && data[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleBlurDate = (e, fieldName) => {
    let { value, name } = e.target;
    let isFromValid = true;
    let isToValid = true;
    const data = { ...noticeData };
    if (fieldName === "StartDate") {
      if (data.EndDate && new Date(value) > new Date(data.EndDate)) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "EndDate") {
      if (data.StartDate && new Date(value) < new Date(data.StartDate)) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    // const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate;

    let updatedParam = {
      ...data,
      StartDate:
        fieldName === "StartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : data.StartDate, // preserve existing value
      EndDate:
        fieldName === "EndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : data.EndDate, // preserve existing value
    };

    dispatch(noticeAction?.setNoticeData(updatedParam));

    // let { name, value } = e.target;

    // const { error } = postalMailSchema(mailDocumentInfo);
    const { error } = noticeSchema(updatedParam);

    if (error?.details) {
      // Extract the error message for the specific field
      const fieldError = error.details.find((e) => e.path.toString() === name);

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
      }));

      // Select the input element
      const element = document.querySelector(`[name="${name}"]`);

      if (element) {
        if (fieldError) {
          // Add the error class if there's a validation issue
          element.classList.add("input-error");
        } else {
          // Remove the error class if validation passes
          element.classList.remove("input-error");
        }
      }
    } else {
      // Clear the error message if there's no validation error
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      // Remove the error class from the input field
      const element = document.querySelector(`[name="${name}"]`);
      if (element) {
        element.classList.remove("input-error");
      }
    }
  };

  const handleChangeForDate = (input, date) => {
    const data = { ...noticeData };

    if (!date) {
      data[input] = "";
    } else {
      const selectedDate = date instanceof Date ? date : new Date(date);

      const formattedDate =
        `${String(selectedDate.getMonth() + 1).padStart(2, "0")}/` +
        `${String(selectedDate.getDate()).padStart(2, "0")}/` +
        `${selectedDate.getFullYear()}`;

      data[input] = formattedDate;
      if (input === "StartDate") {
        data["StartDate"] = formattedDate;

        if (
          data["EndDate"] &&
          new Date(selectedDate) > new Date(data["EndDate"])
        ) {
          data["EndDate"] = "";
        }
      } else if (input === "EndDate") {
        data["EndDate"] = formattedDate;

        if (
          data["StartDate"] &&
          new Date(selectedDate) < new Date(data["StartDate"])
        ) {
          data["EndDate"] = "";
        }
      } else {
        data[input] = formattedDate;
      }
    }

    dispatch(noticeAction.setNoticeData({ ...data }));
  };

  const handleKiosks = (e, i) => {
    const noticeInfo = { ...noticeData };
    const { checked, value } = e?.target;

    //for showing checkbox
    const dropDownData = [...KIOSKDropDown];
    const updateDropDownValue = {
      ...dropDownData[i],
      isActive: checked,
    };
    dropDownData[i] = updateDropDownValue;
    setKIOSKDropDown(dropDownData);

    const NoticePermissionList = checked
      ? [
        ...noticeData?.NoticePermissionList,
        { KiosksID: parseInt(value), FacilityID: facilityCode },
      ]
      : noticeData?.NoticePermissionList?.filter(
        (item) => item.KiosksID !== parseInt(value)
      );

    const updateToNoticeData = {
      ...noticeData,
      NoticePermissionList,
    };

    dispatch(noticeAction?.setNoticeData(updateToNoticeData));

    //check if all the checkbox is true
    const isAllCheckboxIsActive = dropDownData?.every(
      (item, i) => item?.isActive === true
    );
    isAllCheckboxIsActive
      ? setIsKisoksSelectAll(true)
      : setIsKisoksSelectAll(false);
  };

  const handleKiosksClone = (e, index) => {
    const { checked, value } = e?.target;
    const noticeInfo = { ...noticeData };
    const kiosksList = [...KIOSKDropDownResponse];
    const forAPI = [...noticeInfo?.NoticePermissionList];
    const updateKIOSKSList = kiosksList?.map((item, i) => {
      if (i === index) {
        if (checked) {
          forAPI.push({
            KiosksID: parseInt(value),
            FacilityID: facilityCode,
          });
          noticeInfo.NoticePermissionList = forAPI;
          dispatch(noticeAction?.setNoticeData(noticeInfo));
        } else {
          const fileteredData = noticeData?.NoticePermissionList?.filter(
            (item) => item.KiosksID !== parseInt(value)
          );
          noticeInfo.NoticePermissionList = fileteredData;

          dispatch(noticeAction?.setNoticeData(noticeInfo));
        }
        return { ...item, isActive: checked };
      }
      return item;
    });

    dispatch(noticeAction?.updateKIOSKList(updateKIOSKSList));

    // //check if all the checkbox is true
    const isAllCheckboxIsActive = updateKIOSKSList?.every(
      (item, i) => item?.isActive === true
    );
    isAllCheckboxIsActive
      ? setIsKisoksSelectAll(true)
      : setIsKisoksSelectAll(false);
  };

  const handleKiosksSelectAll = (e) => {
    const { checked } = e?.target;
    setIsKisoksSelectAll(checked);
    // const updatedDropDownValue = KIOSKDropDown?.map((item, index) => ({
    //   ...item,
    //   isActive: checked,
    //   KiosksID: item?.value,
    //   FacilityID: facilityCode,
    // }));
    // setKIOSKDropDown(updatedDropDownValue);
    // const updateToNoticeData = {
    //   ...noticeData,
    //   NoticePermissionList: checked ? updatedDropDownValue : [],
    // };
    // dispatch(noticeAction?.setNoticeData(updateToNoticeData));

    //new
    const noticeInfo = { ...noticeData };
    const forAPI = [...noticeInfo?.NoticePermissionList];
    const kiosksList = [...KIOSKDropDownResponse];
    const selectedArr = [];
    const updatedDropDownValue = kiosksList?.map((item, index) => {
      if (checked) {
        selectedArr.push({
          KiosksID: parseInt(item?.value, 10),
          FacilityID: facilityCode,
        });
      }
      return { ...item, isActive: checked };
    });

    if (!checked) {
      forAPI.length = 0;
    }

    dispatch(noticeAction?.updateKIOSKList(updatedDropDownValue));

    noticeInfo.NoticePermissionList = selectedArr;
    dispatch(noticeAction?.setNoticeData(noticeInfo));
  };

  const handleBlur = (field) => {
    noticeAction.setNoticeData((prev) => {
      const dateValue = prev[field];
      const isValidDate =
        dateValue &&
        !isNaN(new Date(dateValue).getTime()) &&
        new Date(dateValue).getFullYear() >= 1990;

      if (!isValidDate) {
        return { ...prev, [field]: "" };
      }

      if (
        field === "StartDate" &&
        prev.toDate &&
        new Date(dateValue) > new Date(prev.toDate)
      ) {
        return { ...prev, StartDate: "" };
      }

      if (field === "EndDate") {
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        if (
          (prev.StartDate && new Date(dateValue) < new Date(prev.StartDate)) ||
          new Date(dateValue) > oneMonthAgo
        ) {
          return { ...prev, EndDate: "" };
        }
      }

      return prev;
    });
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    const noticeInfo = { ...noticeData, FacilityID: commonFacilityCode };
    if (noticeID > 0) {
      setinsetupdateflag(1);
      noticeInfo.Action = 2;
      noticeInfo.NoticeID = noticeID;
      noticeInfo.IsExistingNotice = 0;
      // noticeInfo.FacilityID = commonFacilityCode
      dispatch(noticeAction?.setNoticeData(noticeInfo));
    } else {
      setinsetupdateflag(0);
      dispatch(noticeAction?.setNoticeData(noticeInfo));
    }

    setSubmit(true);
    setErrorMessage({});
    const errorElements = document.querySelectorAll(".input-error");
    if (errorElements?.length > 0) {
      errorElements.forEach((element) =>
        element.classList.remove("input-error")
      );
    }

    const { error } = noticeSchema(noticeInfo);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e?.message,
        }));
        const className = path.join(".");
        const escapedName = className.replace(/\./g, "\\.");
        const element = document.querySelector(`[name=${escapedName}]`);
        if (element) {
          element?.classList?.add("input-error", className);
        } else {
          //for editor
          const editorElements = document.getElementsByClassName(escapedName);

          if (editorElements.length > 0) {
            for (let i = 0; i < editorElements.length; i++) {
              editorElements[i]?.classList?.add("input-error", className);
            }
          }
        }
      });
      return;
    }
    dispatch(
      authActions.GetManagementUserAccessPermission({
        ManagementUserID: user.ManagementUserID,
        ManagementMenuID: MenuItem.NoticesMenuItem,
      })
    )
      .then((res) => {
        const shouldEnableModifyOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Modify" &&
                item?.SubMenuActiveStatus === 1
            )
            : true;
        const shouldEnableAddOptions =
          Array.isArray(res?.payload) && res?.payload.length > 0
            ? res?.payload.some(
              (item) =>
                item?.SubMenuName === "Add" && item?.SubMenuActiveStatus === 1
            )
            : true;
        if (!shouldEnableModifyOptions && noticeData?.NoticeID) {
          showToastNotification(
            "Update notice has been disabled by the admin.",
            "error"
          );
          return;
        }
        if (!shouldEnableAddOptions && !noticeData?.NoticeID) {
          showToastNotification(
            "Add notice has been disabled by the admin.",
            "error"
          );
          return;
        }
        dispatch(noticeAction?.addOrUpdateNotice(noticeInfo));
      })
      .catch((e) => { });
  };

  const CustomStyles = `
.ql-picker.ql-font .ql-picker-label::before,
.ql-picker.ql-font .ql-picker-item::before {
    font-family: initial !important;  /* Reset to default font */
    content: attr(data-value) !important;  /* Show font name */
    text-transform: capitalize !important;  /* Capitalize first letter */
    font-size: 16px !important;  /* Increase font size */
}

  .ql-picker.ql-font { width: 160px !important; }

    .ql-picker.ql-size .ql-picker-label::before,
    .ql-picker.ql-size .ql-picker-item::before {
        content: attr(data-value) !important;
        text-transform: none !important;
    }
        .ql-font-arial { font-family: Arial, sans-serif; }
        .ql-font-courier-new { font-family: Courier-New, monospace; }
        .ql-font-georgia { font-family: Georgia, serif; }
        .ql-font-tahoma { font-family: Tahoma, sans-serif; }
        .ql-font-times-new-roman { font-family: Times-New-Roman, serif; }
        .ql-font-verdana { font-family: Verdana, sans-serif; }
        .ql-font-impact { font-family: Impact, sans-serif; }
        .ql-font-wingdings { font-family: Wingdings; }

         /* Hide only the preview inside the tooltip */
        .ql-tooltip .ql-preview {
            max-width: 7px !important;
            height: 0px !important;
            overflow: hidden !important;
            white-space: nowrap !important;
            display: inline-block !important;
            visibility: hidden; /* Hides text but keeps the element */
        }
        .ql-snow .ql-tooltip::before {
            content: none !important; /* Removes the "Visit URL:" text */
        }
      .ql-snow .ql-tooltip a.ql-action::after {
          border-right: 1px solid #ccc;
          content: 'Edit';
          margin-left: 7px;
          padding-right: 8px;
      }
`;

  const handleBack = () => {
    history?.navigate("NoticeList");
    //dispatch(noticeAction.resetNoticeSearch());
  };

  if (loading) return <CustomLoader />;


  return (
    <>
      {/* <div dangerouslySetInnerHTML={{ __html: noticeData?.NoticeDispaly }} /> */}
      <div className="card  shadow-sm b-r-all  p-4 border border-dark-grey mt-3  w-100 mb-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
          <h2 className="form_title_uppercase text-color">
            {noticeID > 0 ? "Edit" : "Add"} Notice
          </h2>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            variant="danger"
            icon={"fa-solid fa-angle-left"}
            status={"primary"}
            disabled={false}
            onClick={() => handleBack()}
          />
        </div>
        <h4 className="inner-header-bg text-color">
          {" "}
          <i className="fa-solid fa-circle-info me-2"></i>Notice Information
        </h4>
        <div className="card-body w-100 mx-auto">
          <form onSubmit={(e) => handleSubmit(e)}>
            {/* Title Input */}
            <div className="col-md-12">
              <TextInput
                name="NoticeTitle"
                label="Title"
                placeholder="Enter Title"
                required
                maxLength={30}
                handleChange={handleChange}
                //  handleChange={(e) => handleChange(e, "NoticeTitle")}
                handleBlur={() =>
                  handleOnBlur({ target: { name: "NoticeTitle" } })
                }
                value={noticeData?.NoticeTitle}
                errorMessage={errorMessage}
              />
            </div>

            <div>
              <label
                className="form-label col-form-label col-md-3 w-100 fs-5 mt-3"
                style={{ color: "#20252aa6", fontWeight: "400" }}
              >
                Description {<span className="text-danger">*</span>}
              </label>
              {/* 
              <Editor
                name={"NoticeDispaly"}
                customStyleMap={customStyleMap}
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName={`notice-editor-block NoticeDispaly ${
                  errorMessage["NoticeDispaly"] ? "input-error" : ""
                }`.trim()}
                onEditorStateChange={onEditorStateChange}
              /> */}
              <div
                className="quill-container jjj"
                // handleBlur={() =>
                //   handleOnBlur({ target: { name: "NoticeDispaly" } })
                // }
                id="toolbar"
              >
                <style>{CustomStyles}</style>
                <div onPaste={handlePaste} onContextMenu={handleContextMenu}>
                  <ReactQuill
                    theme="snow"
                    ref={(el) => {
                      if (el) quillRef.current = el;
                    }}
                    value={editorContent}
                    onChange={onEditorStateChange}
                    onBlur={() =>
                      handleOnBlur({ target: { name: "NoticeDispaly" } })
                    }
                    // modules={{
                    //   toolbar: [
                    //     [{ font: [] }],
                    //     [{ size: [] }],
                    //     [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    //     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    //     [{ list: 'ordered' }, { list: 'bullet' }],
                    //     [{ script: 'sub' }, { script: 'super' }],
                    //     [{ indent: '-1' }, { indent: '+1' }],
                    //     [{ direction: 'rtl' }],
                    //     [{ color: [] }, { background: [] }],
                    //     [{ align: [] }],
                    //     ['link', 'image', 'video'],
                    //     ['clean']
                    //   ],
                    // }}

                    modules={modules}
                    className={`notice-editor-block ${errorMessage["NoticeDispaly"] ? "input-error" : ""
                      }`}
                  />
                </div>
              </div>

              {errorMessage?.NoticeDispaly && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.NoticeDispaly}
                </div>
              )}
            </div>

            <div className="row col-lg-12">
              {/* Date Pickers */}
              <div className="col-md-6 mt-3">
                <DateInput
                  label="Start Date"
                  name="StartDate"
                  value={noticeData?.StartDate}
                  maxDate={
                    noticeData?.EndDate ? new Date(noticeData?.EndDate) : ""
                  }
                  minDate={new Date(1900, 0, 1)}
                  handleChange={(e) => handleChange(e, "StartDate")}
                  placeholderText="Select a start date"
                  isClearable={noticeData?.StartDate}
                  required
                  handleBlur={(e) => handleBlurDate(e, "StartDate")}
                  // handleBlur={() =>
                  //   handleOnBlur({ target: { name: "NoticeDispaly" } })
                  // }
                  errorMessage={errorMessage}
                  handleKeyDown={(e) => handleDateEnterKey(e, "StartDate")}
                />
                {/* <DatePickerComponent
                  label="Start Date"
                  name="StartDate"
                  value={
                    noticeData?.StartDate
                      ? new Date(noticeData?.StartDate)
                      : null
                  }
                   maxDate={
                     noticeData?.EndDate
                       ? new Date(noticeData?.EndDate)
                       : ""
                   }
                  onChange={(date) => handleChangeForDate("StartDate", date)}
                  placeholderText="Select a start date"
                  errorMessage={errorMessage}
                  onBlur={() => handleBlur("StartDate")}
                  required={true}
                  disabled={false}
                  yearDropDown={true}
                  monthDropDown={true}
                  showTimeSelect={false}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  isClearable = {noticeData?.StartDate}
                /> */}
              </div>
              <div className="col-md-6 mt-3">
                <DateInput
                  label="End Date"
                  name="EndDate"
                  value={noticeData?.EndDate}
                  required
                  minDate={
                    noticeData?.StartDate
                      ? new Date(noticeData?.StartDate)
                      : new Date(1900, 0, 1)
                  }
                  handleChange={(date) => handleChangeForDate("EndDate", date)}
                  placeholderText="Select a End date"
                  isClearable={noticeData?.EndDate}
                  handleBlur={(e) => handleBlurDate(e, "EndDate")}
                  errorMessage={errorMessage}
                  handleKeyDown={(e) => handleDateEnterKey(e, "EndDate")}
                />
                {/* <DatePickerComponent
                  label="End Date"
                  name="EndDate"
                  value={noticeData?.EndDate}
                  minDate={
                    noticeData?.StartDate
                      ? new Date(noticeData?.StartDate)
                      : undefined
                  }
                  // maxDate={new Date(new Date().setMonth(new Date().getMonth()))}
                  onChange={(date) => handleChangeForDate("EndDate", date)}
                  placeholderText="Select a End date"
                  errorMessage={errorMessage}
                  onBlur={() => handleBlur("EndDate")}
                  required={true}
                  disabled={false}
                  yearDropDown={true}
                  monthDropDown={true}
                  showTimeSelect={false}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  isClearable={noticeData?.EndDate}
                /> */}
              </div>
            </div>
            <div className="col-md-12 mt-3 rounded overflow-auto">
              <label
                className="form-label col-form-label col-md-3 w-100 fs-5"
                style={{ color: "#20252aa6", fontWeight: "400" }}
              >
                Kiosks {<span className="text-danger">*</span>}
              </label>
              {errorMessage && Object?.keys(errorMessage).length > 0 && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage &&
                    errorMessage["NoticePermissionList"] &&
                    errorMessage["NoticePermissionList"]}
                </div>
              )}
              <CheckBoxInput
                label="Select / Unselect All"
                name="isKisoksSelectAll"
                id="isKisoksSelectAll"
                handleClick={(e) => handleKiosksSelectAll(e)}
                checked={isKisoksSelectAll}
                // handleBlur={(e) => {
                //   handleOnBlur(e, "NoticePermissionList");
                // }}
                handleBlur={() =>
                  handleOnBlur({ target: { name: "NoticePermissionList" } })
                }
              />

              {KIOSKDropDownResponse?.map((form, i) => {
                return (
                  <div key={i}>
                    <CheckBoxInput
                      label={form?.label}
                      name={form?.label}
                      id={form?.value}
                      value={form?.value}
                      // disabled={!facilityInformationData?.IsFormReqAccess}
                      handleClick={(e) => handleKiosksClone(e, i)}
                      checked={
                        KIOSKDropDownResponse[i]?.["isActive"] ||
                        isKisoksSelectAll
                      }
                      // handleBlur={(e) => {
                      //   handleOnBlur(e, "NoticePermissionList");
                      // }}
                      handleBlur={() =>
                        handleOnBlur({
                          target: { name: "NoticePermissionList" },
                        })
                      }
                    />
                  </div>
                );
              })}
            </div>
            {/* Status Radio Input */}
            <div className="col-md-8 mt-2">
              <RadioInput
                name="ActiveStatus"
                id="ActiveStatus"
                label="Status"
                options={Status}
                // required
                handleChange={(e) => handleChange(e)}
                selectedValue={noticeData?.ActiveStatus}
              />
            </div>

            {/* Buttons */}
            <div className="mt-3 d-flex justify-content-center gap-3">
              <Button
                className="me-2"
                label={noticeID ? "Update" : "Save"}
                type="submit"
                variant="danger"
                status={"success"}
                icon={"fa-solid fa-floppy-disk"}
                disabled={false}
              />
              <Button
                variant="secondary"
                className="me-2"
                onClick={handleReset}
                label={"RESET"}
                type={"button"}
                status={"secondary"}
                disabled={false}
                icon={"fa-solid fa-rotate-right"}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default React.memo(AddOrEditNotice);
